export default __webpack_public_path__ + "static/media/card_front_exp.6e419fc9.svg";